import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

import { VerticalDivider } from '../Divider/Divider'
import { LinkButton } from '../Button/LinkButton'

import { EmailContactFilter } from './EmailContactFilter'
import { EmailDateFilter } from './EmailDateFilter'
import { EmailFilterModal } from './EmailFilterModal'
import { EmailQuickFilter } from './EmailQuickFilters'
import { EmailFilterButtons } from './EmailFilterButtons'

import './EmailFilters.scss'

interface EmailFiltersProps {
  withoutQuickFilter?: boolean
  withoutContactFilter?: boolean
}

export const EmailFilters: React.FC<EmailFiltersProps> = ({ withoutQuickFilter = false, withoutContactFilter = false }) => {
  return (
    <>
      <EmailFilterModal withoutQuickFilter={withoutQuickFilter} withoutContactFilter={withoutContactFilter} />
      <Container fluid>
        <Row className='g-3'>
          {!withoutQuickFilter ? (
            <Col>
              <EmailQuickFilter />
            </Col>
          ) : null}
          {!withoutContactFilter ? (
            <Col>
              <EmailContactFilter />
            </Col>
          ) : null}
          <Col>
            <EmailDateFilter />
          </Col>
          <Col xs={'auto'}>
            <EmailFilterButtons withoutContactFilter={withoutContactFilter} />
          </Col>
          <Col xs={'auto'}>
            <div className='d-flex h-100 align-items-end'>
              <div className='d-flex align-items-center gap-3'>
                <VerticalDivider className='zocks-py-0.75' />
                <LinkButton variant='primary' to='/email/new' className='text-nowrap'>
                  New email
                </LinkButton>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}
